import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import TabController from "./../../factories/tab-controller";
class InformationSapItem {
    ReportedBy = ko.observable<string>("");
    SapNumber: KnockoutObservable<string> = ko.observable("");
    SapWorkCenterId: KnockoutObservable<string> = ko.observable("");
    SapWorkCenter: KnockoutObservable<string> = ko.observable("");
    SearcherCodeGroup = ko.observable()
    SysStatus: KnockoutObservable<string> = ko.observable("");
    FunctionalLocation: KnockoutObservable<string> = ko.observable("");
    SapWorkCenterName : KnockoutObservable<string> = ko.observable("");
    FunctionalLocationDescription: KnockoutObservable<string> = ko.observable("");
    FunctionalLocationDescriptionLong: KnockoutObservable<string> = ko.observable("");
    AreaSapId: KnockoutObservable<string> = ko.observable("");
    Equipment: KnockoutObservable<string> = ko.observable("");
    EquipmentStrukturnummer: KnockoutObservable<string> = ko.observable("");
    EquipmentDescriptionLong: KnockoutObservable<string> = ko.observable("");
    Text1: KnockoutObservable<string> = ko.observable("");
    Text2: KnockoutObservable<string> = ko.observable("");
    Priority: KnockoutObservable<string> = ko.observable("");
    PriorityType: KnockoutObservable<string> = ko.observable("");
    PriorityTypeDescriptionLong: KnockoutObservable<string> = ko.observable("");
    Coding: KnockoutObservable<string> = ko.observable("");
    CodingDescription: KnockoutObservable<string> = ko.observable("");
    CodingExtDescription: KnockoutObservable<string> = ko.observable("");
    CodeGroupExtDescription: KnockoutObservable<string> = ko.observable("");
    CodeGroupExtDescriptionLong: KnockoutObservable<string> = ko.observable("");
    InfoSapId: KnockoutObservable<string> = ko.observable("");
    TabName: KnockoutObservable<string> = ko.observable("");

    HasSapNumber = ko.observable(false);
    
    TabPage: TabPage;
    infoVM = ko.observable<any>();
    constructor(infoVM: any, tabPage: any) {
        this.TabPage = tabPage;
        this.infoVM = ko.observable(infoVM);
        this.infoVM().TabPage.Title.subscribe(() => { this.init(); });

        Bao.bindEvent('infoSapTab:refresh', () => {
            this.LoadSapData();
        });
    }
    
    LoadSapData(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post("InfoSap/GetInfoSap", JSON.stringify({
            id: this.infoVM().InfoSapId()
        }), (result) => {
            var mappedItem = ko.map.fromJS(result.Model, this);
            if (result.Model.InfoSapId) {
                //this.HasSapNumber(true);
                this.infoVM().HasSapNumber(true);
                //let d: Factories.TabController = this.TabPage.$TabController;
                //this.TabPage = new TabPage();
                //this.TabPage.IsClosable(false);
                //this.TabPage.Url("InfoSap");
                //d.AddTab(this.TabPage);
            }
            else {
                //this.HasSapNumber(false);
                this.infoVM().HasSapNumber(false);
                //let d: Factories.TabController = this.TabPage.$TabController; 
                //d.RemoveTab(this.TabPage);
            }
            this.TabPage.Title(this.TabName());
            this.TabPage.IsLoading(false);
        });
    }
    init() {
        this.LoadSapData().done(function () {
        });
    }
    loaded() {
    }
}
export default InformationSapItem;